module.exports = __webpack_public_path__ + "img/s1-1.db8e2cee.svg";